module.exports = __webpack_public_path__ + "img/arrow.a62b3689.png";